import { audiogramHelpers } from './helpers';
import { AudiogramGenerationStatus } from './preview/AudiogramGenerationStatus';
import { AudiogramPreview } from './preview/AudiogramPreview';
import { AudiogramExport } from './social-export/AudiogramExport';
import { useFragment } from '../../hooks/useFragment';

export function FragmentAudiogramTab() {
  const { fragment } = useFragment();

  if (audiogramHelpers.isGenerationStarted(fragment)) {
    return (
      <>
        <AudiogramGenerationStatus />
        <AudiogramExport />
      </>
    );
  }

  return <AudiogramPreview />;
}
